var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 30,
    "data-tags": "tiktok",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.692 2.42c1.118-.02 2.227-.01 3.337-.02.068 1.567.537 3.164 1.493 4.27.956 1.137 2.304 1.659 3.618 1.833v4.127c-1.229-.051-2.466-.359-3.584-.994-.486-.266-.938-.604-1.382-.952-.009 2.99.008 5.98-.017 8.96-.068 1.434-.461 2.857-1.152 4.035-1.118 1.966-3.055 3.246-5.043 3.287-1.22.082-2.44-.318-3.482-1.055-1.724-1.219-2.935-3.45-3.115-5.847a22.788 22.788 0 01-.008-1.526c.153-1.945.956-3.81 2.201-5.079 1.417-1.474 3.397-2.18 5.248-1.761.017 1.515-.034 3.03-.034 4.546-.845-.327-1.834-.235-2.577.38-.537.42-.947 1.064-1.16 1.791-.18.523-.128 1.096-.12 1.649.205 1.68 1.553 3.092 2.987 2.939.956-.01 1.869-.676 2.364-1.649.162-.338.341-.686.35-1.085.085-1.833.05-3.656.06-5.489.008-4.127-.01-8.243.016-12.36z",
    fill: "#333"
  })));
}
export default SvgTiktokIcon;